<div
  class="tooltip-wrapper"
  [style.top]="mouseHeight + 'px'"
  [style.left]="parentWidth + leftPadding + 'px'"
>
  <div class="metric-wrapper" *ngFor="let keyPair of displayValues | keyvalue: originalOrder">
    <span>{{ keyPair.key + ": " }}</span
    ><span>{{ keyPair.value }}</span>
  </div>
</div>
